import api from "./instance";
import { getStaffId } from "../utils/storage";
import { userBody } from "./requestHelpers";

export const getCart = () => {
  const userId = getStaffId();
  if (!userId) {
    return Promise.resolve({ data: { items: [], grandTotal: 0 } });
  }
  return api.post("/staff/mycart", { userId });
};

export const addToCart = (_staffId, payload) =>
  api.post("/staff/addcart", userBody(payload));

export const deleteFromCart = (_staffId, payload) =>
  api.delete("/staff/deletecart", { data: userBody(payload) });
